import { render, staticRenderFns } from "./helpList.vue?vue&type=template&id=0b5991ff&scoped=true"
import script from "./helpList.vue?vue&type=script&lang=js"
export * from "./helpList.vue?vue&type=script&lang=js"
import style0 from "./helpList.vue?vue&type=style&index=0&id=0b5991ff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5991ff",
  null
  
)

export default component.exports